export interface CourierModel {
    lgxCourierShipmentId: string;
    numberOfSamples?: string;
    shipmentStatus?: string;
    isSponsorModel?: boolean;
}

export interface CourierDetails {
    shipmentId?: number;
    courierCode?: string;
    courierTrackingNumber?: string;
    waybillNumber?: string;
    courierName?: string;
    destinationCountry?: string;
    receiverName?: string;
    estimatedDeliveryDate?: string;
    originCountry?: string;
    locationOfScan?: string;
    shipmentStatusName?: string;
    shipmentStatusCode?: string;
    origin?: string;
    destinationCountryISO2?: string;
    destinationCountryISO3?: string;
    receiverPostalCode?: string;
    receiverCity?: string;
    receiverAddressLine1?: string;
    receiverAddressLine2?: string;
    originCountryISO2?: string;
    originCountryISO3?: string;
    shipperPostalCode?: string;
    originCity?: string;
    locationOfScanAddressLine1?: string;
    locationOfScanAddressLine2?: string;
    originName?: string;
    destination?: string;
    formatedDeliveryDate?: string;
    shipmentStatus?: string;
    courierActivityData?: SampleActivity[];
    formatedCourierData?: SampleActivity[];
    courierStatusMappingData?: CourierMappingData[];
}

export interface SampleActivity {
    iconUrl?: string;
    activityStatus: string;
    activityDescription: string;
    activityOccurredonDate: string;
    collectionDate?: string;
    collectionTime?: string;
    fromLocation?: string;
    toLocation?: string;
    cancellationDescription?: string;
    airwayBillNumber?: string;
    hideDescription?: boolean;
    formattedDateTime?: string;
    location?: string;
    shipmentId?: number;
    courierTrackingNumber?: string;
    courierTimestamp?: string;
    type?: string;
    courierDescription?: string;
    helptext?: string;
}

export interface CourierMappingData {
    courierCode: string;
    courierStatus: string;
    portalStatus: string;
    courierId?: number;
}

export enum CourierStatusIconMapping {
    cancelled_returned = 'cancelled_returned',
    delivered = 'delivered',
    generic_icon = '',
    on_hold_delayed = 'on_hold_delayed',
    shipped = 'shipped',
    in_transit = 'in_transit',
}